import React from "react";

// A vista em tabela de cada grafico (spec do RPAA-286, decisao 12): os mesmos numeros, para quem nao
// ve as cores, para o leitor de ecra e para copiar. Uma coluna com `format` mostra o valor da linha
// formatado; a linha guarda-o em bruto, que e o que "Descarregar esta tabela" leva (entrega 5 do redesign).
const cellBorder = { borderBottom: "1px solid var(--color-border)" };

// O `relative` pela mesma razao da lista de conversas: a legenda `sr-only` e `position: absolute`, e
// sem um antepassado posicionado dentro do <main> a caixa dela conta para a raiz do documento. Com a
// pagina toda, cinco legendas davam 4485px de documento numa janela de 1152, e o <main> subia com o
// scroll da janela, deixando vazio por baixo.
// Uma coluna com `downloadOnly` so existe no ficheiro (o ChartFrame), e a tabela nao a desenha.
const DataTable = ({ caption, columns: allColumns, rows }) => {
  const columns = allColumns.filter((column) => !column.downloadOnly);
  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm">
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                scope="col"
                className={`py-1.5 px-2 font-medium ${column.numeric ? "text-right" : "text-left"}`}
                style={{ color: "var(--color-text-secondary)", ...cellBorder }}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`py-1.5 px-2 ${column.numeric ? "text-right tabular-nums" : ""}`}
                  style={{ color: "var(--color-text-primary)", ...cellBorder }}
                >
                  {column.format
                    ? column.format(row[column.key])
                    : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
